module.exports = __webpack_public_path__ + "static/media/yamaha-blue-bike.bf38b758.jpeg";